import { createRouter, createWebHistory } from 'vue-router';

import AVosKidsPage from '@/views/AVosKidsPage.vue';
import BayardPage from '@/views/BayardPage.vue';
import ChirpPage from '@/views/ChirpPage.vue';
import HomePage from '@/views/HomePage.vue';
import ILEMPage from '@/views/ILEMPage.vue';
import JmcPage from '@/views/JmcPage.vue';
import { bayardMagazineGuard } from '@/guards/bayard-magazine-guard';

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/a-vos-kids",
    name: "launchMontessori",
    component: AVosKidsPage,
  },
  {
    path: "/jungle-math",
    name: "launchJungleMath",
    component: JmcPage,
  },
  {
    path: "/maternelle-montessori",
    name: "launchMontessoriBayard",
    component: BayardPage
  },
  {
    path: "/chirp",
    name: "chirp",
    component: ChirpPage
  },
  {
    path: "/i-love-english",
    name: "ilem",
    component: ILEMPage,
    beforeEnter: bayardMagazineGuard
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
